import React from "react";
import { inject, observer } from "mobx-react";
import BroadcastStore from "../_stores/broadcast/BroadcastStore";
import usePausedShowCountdown from "../usePausedShowCountdown";

interface Props {
  broadcastStore?: BroadcastStore;
}

const BroadcastPausedCounter: React.FunctionComponent<Props> = ({
  broadcastStore,
}) => {
  const { restoreFreeShow, broadcasterVariant } = broadcastStore!;
  const timer = usePausedShowCountdown(restoreFreeShow, broadcasterVariant);

  return (
    <div className='BroadcastOBSTimer paused h-64 z-10'>
      <div className={`BroadcastOBSTimer__video`}></div>
      <div className='BroadcastOBSTimer__overlay'>
        <div className='BroadcastOBSTimer__timer'>{timer}</div>
      </div>
    </div>
  );
};

export default inject("broadcastStore")(observer(BroadcastPausedCounter));
